var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',{staticClass:"BlockStat",class:{ 'BlockStat--dark': _vm.dark }},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('p',_vm._g(_vm._b({},'p',attrs,false),on),[_vm._v(_vm._s(_vm.value))])])]}}])},[_c('span',[_vm._v(_vm._s(_vm.raw))])])}
var staticRenderFns = []

export { render, staticRenderFns }